import React from 'react'
import { RoomModel } from '../../common/models/RoomModel.js'
import { BaseCalendar } from './BaseCalendar.js'

export interface CalendarProps {
    rooms: RoomModel[]
}

export function Calendar(props: CalendarProps) {
    const { rooms } = props

    return (
        <div className="px-6 pb-16 w-full">
            <BaseCalendar
                rooms={rooms}
                singleRoom={false}
                className="mb-4"
            />
        </div>
    )
}
